import { environment } from '@environments/environment';
import { License } from '@microblink/blinkcard-capacitor';

export const FIREBASECONFIG = {
	apiKey: 'AIzaSyAv1isqvrDkoVmzO1wtYrfkdJKlcQ_RVGo',
	authDomain: 'vquipos.firebaseapp.com',
	projectId: 'vquipos',
	storageBucket: 'vquipos.appspot.com',
	messagingSenderId: '188964562916',
	appId: '1:188964562916:web:12d1042ec6d26a59d209f1',
	measurementId: 'G-0XG7LBP92J',
};
export const CDN_URL = `https://cdn.vquiprentals.com`;
export const LOGGER_NAME = 'vquipOs.authenticated';
export const RXJS_DELAY = environment.rxjs_delay;
export const API_RETRY_COUNT = 1;
export const API_RETRY_DELAY = 1000;
export const DATE_TIME_ZONE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const YEAR_MONTH_DAY = 'YYYY-MM-DD';
export const DOB_FORMAT = 'MM/DD/YYYY';
export const SERVER_ERROR_MESSAGE = ['There was an issue with your request, please try again. If this issue persists, please contact vQuip support'];
export const CACHE_TIMEOUT = 1;
export const FIVE_MIN_CACHE_TIMEOUT = 1;

export const SCHEDULE_LIST_URL = `/app/tabs/schedule?refresh=true`;
export const SCHEDULE_LIST_URL_NO_REFRESH = `/app/tabs/schedule`;
export const CHARGE_TYPES = [
	{ name: 'Add On', value: 'add on' },
	{ name: 'Captain Fee', value: 'captain fee' },
	{ name: 'Damage Fee', value: 'damage fee' },
	{ name: 'Discount', value: 'discount' },
	{ name: 'Fuel Charge', value: 'fuel charge' },
	{ name: 'General', value: 'general' },
	{ name: 'Tip', value: 'tip' },
];

export const DEV_APP_LIST = [
	{ id: '00102', username: 'jg+son@jtmg.io', env: 'envDev' },
	{ id: '00165', username: 'jg@jtmg.io', env: 'envDev' },
	{ id: '00165', username: 'josh@vquiprentals.com', env: 'envDev' },
	{ id: '00102', username: 'jg+jonah@jtmg.io', env: 'envDev' },
	{ id: '00102', username: 'jg+son-local@jtmg.io', env: 'envLocal' },
	{ id: '0089', username: 'jake+cliff@vquiprentals.com', env: '' },
	{ id: '0089', username: 'josh@vquiprentals.com', env: 'envDev' },
	{ id: '0089', username: 'jg+login@jtmg.io', env: 'envDev' },
	{ id: '00112', username: 'jack+tombrady@vquiprentals.com', env: '' },
	{ id: '00112', username: 'ben+swag@vquiprentals.com', env: '' },
	{ id: '00112', username: 'josh+abc@vquiprentals.com', env: '' },
	{ id: '00112', username: 'kendall+123@vquiprentals.com', env: '' },
	{ id: '00112', username: 'yakira+abc@vquiprentals.com', env: '' },
	{ id: '00112', username: 'jg@jtmg.io', env: '' },
	{ id: '0023', username: 'ben+steez@vquiprentals.com', env: '' },
	{ id: '00125', username: 'yakira+wtfeone@vquiprentals.com', env: '' },
	{ id: '00125', username: 'josh+wtf@vquiprentals.com', env: '' },
	{ id: '00149', username: 'yakira+macallanrare@vquiprentals.com', env: '' },
	{ id: '00168', username: 'jg@jtmg.io', env: 'envDev' },
	{ id: '0089', username: 'griffin+marineemployee@vquiprentals.com', env: 'envDev' },
	{ id: '00168', username: 'griffin+powersportsemployee@vquiprentals.com', env: 'envDev' },
	{ id: '00145', username: 'logan@thebahrfamily.com', env: 'envDev' },
	{ id: '00140', username: 'brandon+app@vquiprentals.com', env: 'envDev' },
	{ id: '00161', username: 'jake+employee@vquiprentals.com', env: 'envDev' }
];

export const STAGE_APP_LIST = [
	{ id: '00111', username: 'josh+tide@vquiprentals.com', env: '' },
	{ id: '00111', username: 'baden+htbr@vquiprentals.com', env: '' },
	{ id: '00111', username: 'cam+htbr@vquiprentals.com', env: '' },
	{ id: '00111', username: 'devin+htbr@vquiprentals.com', env: '' },
	{ id: '00111', username: 'haley+htbr@vquiprentals.com', env: '' },
	{ id: '00111', username: 'jack+htbr@vquiprentals.com', env: '' },
	{ id: '00111', username: 'jake+htbr@vquiprentals.com', env: '' },
	{ id: '00111', username: 'kendall+htbr@vquiprentals.com', env: '' },
	{ id: '0098', username: 'yakira+banner@vquiprentals.com', env: 'envStage' },
	{ id: '00161', username: 'griffin+marineemployee2@vquiprentals.com', env: 'envStage' },
	{ id: '00218', username: 'griffin+powersportsemployee2@vquiprentals.com', env: 'envStage' },
	{ id: '00218', username: 'josh@vquiprentals.com', env: 'envStage' },
	{ id: '00161', username: 'josh@vquiprentals.com', env: '' },
];

export const BLINK_CARD_LICENSE_KEYS: License = {
	ios: 'sRwAAAEMY29tLnZxdWlwLm9zDTu1Ovb1dQ5jxbG4lUbH9uJr/8uAerAFMnoDf/LFyvW6zF7k0d3hg/MgSqt0W5ciT0Gvti4YmjqNhmEum1WPwp33te8XjFC73mVyb1u0UjCHCNJLm1X+6Kp9UOZo06oXXVfMUkZVi8Y95ZwMq1DV4+nnNRFgvvtYGJHmYRB2lJadksx1yEkdUzw0oBd3SCkPMD8qnGjIOzosUuGUZn5FO5RWh6hfxsWDiYB+Krs=',
	android:
		'sRwAAAAMY29tLnZxdWlwLm9zRA5BODopuihj7UV899ScDklq0ipcPmm9fZX6Au03hn1m09XCrGjceF4RqgSg9cfq7AWXARMWYE0iuaNftHII2HCfXhIZZtqq7SESY/V64GNZBom21V+hgF4WKGeFpNB45PLVXnc2HK8KKD+9mSouG4IxEYDzJNECJuCoS98fefk0/trdFaDSsVZt3KwjnI8wT8JKxBtS88rF6rj1c3vsIj+OlrqtrBmT/jXZcfo=',
	showTrialLicenseWarning: false,
};

export const BLINK_ID_LICENSE_KEYS: License = {
	ios: 'sRwAAAEMY29tLnZxdWlwLm9zDTu1OpT1dQ5jxcm4lUfH9g0n7V3JgZpd9K6oYl1JqLlvnEbzjFMeiNz6QB0Agw3VwDWvPHefKZWmk7Dnsyo/ImzWmLysfUCqq4gS87EYHC80HNklMU6fpd25VLCHgYHNqD1SIZrOiQveSTUeC2hmcWIa+IXnOFE8PW24bGpBy8Gg7fHp0aw83I77UDbH31JHZaFuvBcrEG/Mw93RXd4LhuxdVxkCu/Q8',
	android:
		'sRwAAAAMY29tLnZxdWlwLm9zRA5BOFgpuihj7T1899WcDmw+uEEIa3llU2JDwpkNi9EO+slroF2UKKtE8jjaLE/oel0O7eQhJmtLZsf36wA/n1vr0leGhtvD9BXQfYn3jx3YZJ/wFmP0WhECKmE2L40WquqnmtTkEknE6NJEe0XuO/bQsfYzgTI78Xzg3UorwPXMbiIl1Hdgv+ZdwvzXpRwXkJHLWhaeaW4RbnJvgtgzlQeP9IUDtBUl',
	showTrialLicenseWarning: false,
};

export const RESERVATION_STATUS_LIST = [
	{
		name: 'Pending Customer Registration',
		key: 'pending',
		icon: 'cog',
	},
	{
		name: 'Ready To Start',
		key: 'readytostart',
		icon: 'cog',
	},
	{
		name: 'Rental In Progress',
		key: 'started',
		icon: 'cog',
	},
	{
		name: 'Rental Completed',
		key: 'ended',
		icon: 'cog',
	},
	{
		name: 'Under Investigation',
		icon: 'cog',
		key: 'underinvestigation',
	},
	{
		name: 'Pending Review',
		icon: 'cog',
		key: 'pendingreview',
	},
	{
		name: 'Cancelled',
		icon: 'cog',
		key: 'cancelled',
	},
	{
		name: 'Ready To Check-In',
		icon: 'cog',
		key: 'readytocheck-in',
	},
	{
		name: 'Finalize',
		icon: 'cog',
		key: 'finalize',
	},
];

export enum RESERVATION_STATUS {
	CLOSED = 2,
	PENDING = 1,
	CANCELLED = 3,
	STARTED = 4,
	ENDED = 5,
	READYTOSTART = 6,
	UNDERINVESTIGATION = 7,
	PENDING_REVIEW = 8,
	READYTOCHECKIN = 9,
	FINALIZE = 10,
}

export enum INVOICE_STATUS {
	OPEN = 1,
	PAID = 2,
	VOID = 3,
	CLOSED = 4,
	PARTIALLY_PAID = 5,
	PARTIALLY_REFUNDED = 6,
	REFUNDED = 7,
	OFFLINE_PAYMENT = 8,
	PENDING_REFUND = 9,
	CASH_ADJUSTMENT = 10,
}
export const INVOICE_STATUS_VERBOSE = {
	1: 'OPEN',
	2: 'Paid',
};

export const CHECKIN_STEPS = [
	{
		step: 0,
		isValid: false,
		active: false,
		name: 'ConfirmDetailsPage',
		route: '/reservation/checkin/$reservationId/$customerId/start',
		path: 'start',
		title: 'Confirm',
	},
	{
		step: 1,
		isValid: false,
		active: false,
		name: 'ManifestPage',
		route: '/reservation/checkin/$reservationId/$customerId/manifest',
		path: 'manifest',
		title: 'Manifest',
	},
	{
		step: 2,
		isValid: false,
		active: false,
		name: 'CheckinPaymentPage',
		route: '/reservation/checkin/$reservationId/$customerId/payment',
		path: 'payment',
		title: 'Payment',
	},
];

export const LAUNCH_STEPS = [
	{
		step: 0,
		isValid: false,
		active: false,
		name: 'SafetyBriefPage',
		route: '/reservation/launch/$reservationId/$customerId/start',
		path: 'start',
		title: 'Safety',
	},
	{
		step: 1,
		isValid: false,
		active: false,
		name: 'EquipmentCheckPage',
		route: '/reservation/launch/$reservationId/$customerId/equipment',
		path: 'equipment',
		title: 'Equipment',
	},
	{
		step: 2,
		isValid: false,
		active: false,
		name: 'ManifestPage',
		route: '/reservation/launch/$reservationId/$customerId/manifest',
		path: 'manifest',
		title: 'Manifest',
	},
	{
		step: 3,
		isValid: false,
		active: false,
		name: 'EmployeeSignoffPage',
		route: '/reservation/launch/$reservationId/$customerId/signoff',
		path: 'signoff',
		title: 'Signoff',
	},
];

export const REVIEW_STEPS = [
	{
		step: 0,
		isValid: false,
		active: false,
		name: 'ReviewReservationPage',
		route: '/reservation/review/$reservationId/$customerId/start',
		path: 'start',
		title: 'Reservation Review',
	},
	{
		step: 1,
		isValid: false,
		active: false,
		name: 'ReviewEquipmentPage',
		route: '/reservation/review/$reservationId/$customerId/equipment',
		path: 'equipment',
		title: 'Product Review',
	},
];

export const FINALIZE_STEPS = [
	{
		step: 0,
		isValid: false,
		active: false,
		name: 'FinalizeReservationPage',
		route: '/reservation/finalize/$reservationId/$customerId/start',
		path: 'start',
		title: 'Finalize',
	},
];

export const CREATE_STEPS = [
	{
		step: 0,
		isValid: false,
		active: true,
		name: 'CreateReservationPage',
		route: '/reservation/create/product',
		path: 'product',
		title: 'Product',
	},
	{
		step: 1,
		isValid: false,
		active: false,
		name: 'CreateCustomerPage',
		route: '/reservation/create/customer',
		path: 'customer',
		title: 'Info',
	},
	{
		step: 2,
		isValid: false,
		active: false,
		name: 'ReservationPaymentPage',
		route: '/reservation/create/payment',
		path: 'payment',
		title: 'Payment',
	},
	{
		step: 3,
		isValid: false,
		active: false,
		name: 'ReservationConfirmPage',
		route: '/reservation/create/confirm',
		path: 'confirm',
		title: 'Confirm',
	},
];

export const PENDING_STEPS = [
	{
		step: 0,
		isValid: false,
		active: true,
		name: 'CreateCustomerPage',
		route: '/reservation/pending/$reservationId/$customerId/start',
		path: 'start',
		title: 'Info',
	},
	{
		step: 1,
		isValid: false,
		active: false,
		name: 'ReservationPaymentPage',
		route: '/reservation/pending/$reservationId/$customerId/payment',
		path: 'payment',
		title: 'Payment',
	},
	{
		step: 2,
		isValid: false,
		active: false,
		name: 'ReservationConfirmPage',
		route: '/reservation/pending/$reservationId/$customerId/confirm',
		path: 'confirm',
		title: 'Confirm',
	},
];

export const END_SLIDES = [];
export const PENDING_LAUNCH_STATE = 'pending';
export const ACTIVE_CHECKIN_STATE = 'readytocheck-in';
export const ACTIVE_LAUNCH_STATE = 'launch';
export const READY_TO_START_STATE = 'readytostart';
export const IN_PROGRESS_LAUNCH_STATE = 'started';
export const IN_REVIEW_LAUNCH_STATE = 'review';
export const FINALIZE_LAUNCH_STATE = 'finalize';
export const ENDED_LAUNCH_STATE = 'ended';

export const LAUNCH_FILE_DIRECTORY = 'vquip-stored-images';
export const DOB_DATE_REGEX: RegExp = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
export const CREDIT_CARD_REGEX: RegExp =
	/^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;
export const CVV_REGEX: RegExp = /^[0-9]{3,4}$/;
export const PHONE_REGEX: RegExp = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;

export const NON_INSURABLE_PRODUCT_TYPES = [
	'Activity',
	'High Performance (Not Insurable)',
	'Tour',
	'Go-Kart',
	'Parasail',
	'Cabin',
	'House',
];

export const PHONE_MASK_LIST = [
	{
		name: 'USA/Canada',
		dial_code: '+1',
		code: 'US',
		mask: '+1 000 000 0000',
	},
	{
		name: 'Mexico',
		dial_code: '+52',
		code: 'MX',
		mask: '+52 00 00 00000000000',
	},
	{
		name: 'Germany',
		dial_code: '+49',
		code: 'DE',
		mask: '+49 000 00000000000',
	},
	{
		name: 'United Kingdom',
		dial_code: '+44',
		code: 'GB',
		mask: '+44 000 00000000000',
	},
	{
		name: 'India',
		dial_code: '+91',
		code: 'IN',
		mask: '+91 000 00000000000',
	},
	{
		name: 'Saint Helena, Ascension and Tristan Da Cunha',
		dial_code: '+290',
		code: 'SH',
		mask: '+290 00000000000',
	},
	{
		name: 'Niue',
		dial_code: '+683',
		code: 'NU',
		mask: '+683 00000000000',
	},
	{
		name: 'Tokelau',
		dial_code: '+690',
		code: 'TK',
		mask: '+690 00000000000',
	},
	{
		name: 'Falkland Islands (Malvinas)',
		dial_code: '+500',
		code: 'FK',
		mask: '+500 000000000000',
	},
	{
		name: 'Tonga',
		dial_code: '+676',
		code: 'TO',
		mask: '+676 000000000000',
	},
	{
		name: 'Solomon Islands',
		dial_code: '+677',
		code: 'SB',
		mask: '+677 000000000000',
	},
	{
		name: 'Vanuatu',
		dial_code: '+678',
		code: 'VU',
		mask: '+678 000000000000',
	},
	{
		name: 'Tuvalu',
		dial_code: '+688',
		code: 'TV',
		mask: '+688 000000000000000',
	},

	{
		name: 'Cook Islands',
		dial_code: '+682',
		code: 'CK',
		mask: '+682 00 0000000000',
	},
	{
		name: 'Kiribati',
		dial_code: '+686',
		code: 'KI',
		mask: '+686 00 0000000000',
	},
	{
		name: 'Myanmar',
		dial_code: '+95',
		code: 'MM',
		mask: '+95 000 0000000000',
	},
	{
		name: 'Faroe Islands',
		dial_code: '+298',
		code: 'FO',
		mask: '+298 000 0000000000',
	},
	{
		name: 'Andorra',
		dial_code: '+376',
		code: 'AD',
		mask: '+376 000 0000000000',
	},
	{
		name: 'Bosnia and Herzegovina',
		dial_code: '+387',
		code: 'BA',
		mask: '+387 00 00000000000',
	},
	{
		name: 'Saint Pierre and Miquelon',
		dial_code: '+508',
		code: 'PM',
		mask: '+508 00 00000000000',
	},
	{
		name: 'Suriname',
		dial_code: '+597',
		code: 'SR',
		mask: '+597 000 0000000000',
	},
	{
		name: 'Antarctica',
		dial_code: '+672',
		code: 'AQ',
		mask: '+672 0000000000000000',
	},
	{
		name: 'Wallis and Futuna',
		dial_code: '+681',
		code: 'WF',
		mask: '+681 00 00000000000',
	},
	{
		name: 'Samoa',
		dial_code: '+685',
		code: 'WS',
		mask: '+685 00 00000000000',
	},
	{
		name: 'New Caledonia',
		dial_code: '+687',
		code: 'NC',
		mask: '+687 00 00000000000',
	},
	{
		name: "Korea, Democratic People's Republic of Korea",
		dial_code: '+850',
		code: 'KP',
		mask: '+850 000 0000000000',
	},
	{
		name: 'Mauritius',
		dial_code: '+230',
		code: 'MU',
		mask: '+230 000 00000000000',
	},
	{
		name: 'Sao Tome and Principe',
		dial_code: '+239',
		code: 'ST',
		mask: '+239 00 000000000000',
	},
	{
		name: 'Guinea-Bissau',
		dial_code: '+245',
		code: 'GW',
		mask: '+245 0 0000000000000',
	},
	{
		name: 'British Indian Ocean Territory',
		dial_code: '+246',
		code: 'IO',
		mask: '+246 000 00000000000',
	},
	{
		name: 'Zimbabwe',
		dial_code: '+263',
		code: 'ZW',
		mask: '+263 0 0000000000000',
	},
	{
		name: 'Comoros',
		dial_code: '+269',
		code: 'KM',
		mask: '+269 00 000000000000',
	},
	{
		name: 'Aruba',
		dial_code: '+297',
		code: 'AW',
		mask: '+297 000 00000000000',
	},
	{
		name: 'Greenland',
		dial_code: '+299',
		code: 'GL',
		mask: '+299 00 00 000000000',
	},
	{
		name: 'Iceland',
		dial_code: '+354',
		code: 'IS',
		mask: '+354 000 00000000000',
	},
	{
		name: 'Estonia',
		dial_code: '+372',
		code: 'EE',
		mask: '+372 000 00000000000',
	},
	{
		name: 'Bosnia and Herzegovina',
		dial_code: '+387',
		code: 'BA',
		mask: '+387 00 000000000000',
	},
	{
		name: 'Belize',
		dial_code: '+501',
		code: 'BZ',
		mask: '+501 000 00000000000',
	},
	{
		name: 'Panama',
		dial_code: '+507',
		code: 'PA',
		mask: '+507 000 00000000000',
	},
	{
		name: 'Netherlands Antilles',
		dial_code: '+599',
		code: 'AN',
		mask: '+599 000 00000000000',
	},
	{
		name: 'Malaysia',
		dial_code: '+60',
		code: 'MY',
		mask: '+60 0 000 0000000000',
	},
	{
		name: 'Indonesia',
		dial_code: '+62',
		code: 'ID',
		mask: '+62 00 000 000000000',
	},
	{
		name: 'Singapore',
		dial_code: '+65',
		code: 'SG',
		mask: '+65 0000 00000000000',
	},
	{
		name: 'Timor-Leste',
		dial_code: '+670',
		code: 'TL',
		mask: '+670 000 00000000000',
	},
	{
		name: 'Brunei Darussalam',
		dial_code: '+673',
		code: 'BN',
		mask: '+673 000 00000000000',
	},
	{
		name: 'Nauru',
		dial_code: '+674',
		code: 'NR',
		mask: '+674 000 00000000000',
	},
	{
		name: 'Solomon Islands',
		dial_code: '+677',
		code: 'SB',
		mask: '+677 000 00000000000',
	},
	{
		name: 'Vanuatu',
		dial_code: '+678',
		code: 'VU',
		mask: '+678 00 000000000000',
	},
	{
		name: 'Fiji',
		dial_code: '+679',
		code: 'FJ',
		mask: '+679 00 000000000000',
	},
	{
		name: 'Palau',
		dial_code: '+680',
		code: 'PW',
		mask: '+680 000 00000000000',
	},
	{
		name: 'French Polynesia',
		dial_code: '+689',
		code: 'PF',
		mask: '+689 00 00 000000000',
	},
	{
		name: 'Micronesia, Federated States of Micronesia',
		dial_code: '+691',
		code: 'FM',
		mask: '+691 000 00000000000',
	},
	{
		name: 'Marshall Islands',
		dial_code: '+692',
		code: 'MH',
		mask: '+692 000 00000000000',
	},
	{
		name: 'Myanmar',
		dial_code: '+95',
		code: 'MM',
		mask: '+95 0 000 0000000000',
	},
	{
		name: 'Maldives',
		dial_code: '+960',
		code: 'MV',
		mask: '+960 000 00000000000',
	},
	{
		name: 'Gambia',
		dial_code: '+220',
		code: 'GM',
		mask: '+220 000 00 000000000',
	},
	{
		name: 'Sierra Leone',
		dial_code: '+232',
		code: 'SL',
		mask: '+232 00 0000000000000',
	},
	{
		name: 'Nigeria',
		dial_code: '+234',
		code: 'NG',
		mask: '+234 00 000 000000000',
	},
	{
		name: 'Cameroon',
		dial_code: '+237',
		code: 'CM',
		mask: '+237 0000 00000000000',
	},
	{
		name: 'Cape Verde',
		dial_code: '+238',
		code: 'CV',
		mask: '+238 000 00 000000000',
	},
	{
		name: 'Seychelles',
		dial_code: '+248',
		code: 'SC',
		mask: '+248 0 000 0000000000',
	},
	{
		name: 'Somalia',
		dial_code: '+252',
		code: 'SO',
		mask: '+252 0 000 0000000000',
	},
	{
		name: 'Eritrea',
		dial_code: '+291',
		code: 'ER',
		mask: '+291 0 000 0000000000',
	},
	{
		name: 'Gibraltar',
		dial_code: '+350',
		code: 'GI',
		mask: '+350 000 000000000000',
	},
	{
		name: 'Malta',
		dial_code: '+356',
		code: 'MT',
		mask: '+356 0000 00000000000',
	},
	{
		name: 'Estonia',
		dial_code: '+372',
		code: 'EE',
		mask: '+372 0000 00000000000',
	},
	{
		name: 'Moldova',
		dial_code: '+373',
		code: 'MD',
		mask: '+373 0000 00000000000',
	},
	{
		name: 'Norway',
		dial_code: '+47',
		code: 'NO',
		mask: '+47 000 00 0000000000',
	},
	{
		name: 'Honduras',
		dial_code: '+504',
		code: 'HN',
		mask: '+504 0000 00000000000',
	},
	{
		name: 'Nicaragua',
		dial_code: '+505',
		code: 'NI',
		mask: '+505 0000 00000000000',
	},
	{
		name: 'Costa Rica',
		dial_code: '+506',
		code: 'CR',
		mask: '+506 0000 00000000000',
	},

	{
		name: 'Cuba',
		dial_code: '+53',
		code: 'CU',
		mask: '+53 0 000 00000000000',
	},
	{
		name: 'Malaysia',
		dial_code: '+60',
		code: 'MY',
		mask: '+60 00 000 0000000000',
	},
	{
		name: 'New Zealand',
		dial_code: '+64',
		code: 'NZ',
		mask: '+64 00 000 0000000000',
	},
	{
		name: 'Hong Kong',
		dial_code: '+852',
		code: 'HK',
		mask: '+852 0000 00000000000',
	},
	{
		name: 'Macao',
		dial_code: '+853',
		code: 'MO',
		mask: '+853 0000 00000000000',
	},
	{
		name: 'Taiwan',
		dial_code: '+886',
		code: 'TW',
		mask: '+886 0000 00000000000',
	},
	{
		name: 'Myanmar',
		dial_code: '+95',
		code: 'MM',
		mask: '+95 00 000 0000000000',
	},
	{
		name: 'Lebanon',
		dial_code: '+961',
		code: 'LB',
		mask: '+961 0 000 0000000000',
	},
	{
		name: 'Kuwait',
		dial_code: '+965',
		code: 'KW',
		mask: '+965 0000 00000000000',
	},
	{
		name: 'Yemen',
		dial_code: '+967',
		code: 'YE',
		mask: '+967 0 000 0000000000',
	},
	{
		name: 'Bahrain',
		dial_code: '+973',
		code: 'BH',
		mask: '+973 0000 00000000000',
	},
	{
		name: 'Qatar',
		dial_code: '+974',
		code: 'QA',
		mask: '+974 0000 00000000000',
	},
	{
		name: 'Bhutan',
		dial_code: '+975',
		code: 'BT',
		mask: '+975 0 000 0000000000',
	},
	{
		name: 'Tunisia',
		dial_code: '+216',
		code: 'TN',
		mask: '+216 00 000 0000000000',
	},
	{
		name: 'Libya',
		dial_code: '+218',
		code: 'LY',
		mask: '+218 00 000 0000000000',
	},
	{
		name: 'Mauritania',
		dial_code: '+222',
		code: 'MR',
		mask: '+222 00 00 00000000000',
	},
	{
		name: 'Mali',
		dial_code: '+223',
		code: 'ML',
		mask: '+223 00 00 00000000000',
	},
	{
		name: 'Guinea',
		dial_code: '+224',
		code: 'GN',
		mask: '+224 00 000 0000000000',
	},
	{
		name: "Cote d'Ivoire",
		dial_code: '+225',
		code: 'CI',
		mask: '+225 00 000 0000000000',
	},
	{
		name: 'Burkina Faso',
		dial_code: '+226',
		code: 'BF',
		mask: '+226 00 00 00000000000',
	},
	{
		name: 'Niger',
		dial_code: '+227',
		code: 'NE',
		mask: '+227 00 00 00000000000',
	},
	{
		name: 'Togo',
		dial_code: '+228',
		code: 'TG',
		mask: '+228 00 000 0000000000',
	},
	{
		name: 'Benin',
		dial_code: '+229',
		code: 'BJ',
		mask: '+229 00 00 00000000000',
	},
	{
		name: 'Liberia',
		dial_code: '+231',
		code: 'LR',
		mask: '+231 00 000 0000000000',
	},
	{
		name: 'Central African Republic',
		dial_code: '+236',
		code: 'CF',
		mask: '+236 00 00 00000000000',
	},
	{
		name: 'Gabon',
		dial_code: '+241',
		code: 'GA',
		mask: '+241 0 00 00 000000000',
	},
	{
		name: 'Kenya',
		dial_code: '+254',
		code: 'KE',
		mask: '+254 000 0000000000000',
	},
	{
		name: 'Burundi',
		dial_code: '+257',
		code: 'BI',
		mask: '+257 00 00 00000000000',
	},
	{
		name: 'Mozambique',
		dial_code: '+258',
		code: 'MZ',
		mask: '+258 00 000 0000000000',
	},
	{
		name: 'Mayotte',
		dial_code: '+262',
		code: 'YT',
		mask: '+262 00000 00000000000',
	},
	{
		name: 'Lesotho',
		dial_code: '+266',
		code: 'LS',
		mask: '+266 0 000 00000000000',
	},
	{
		name: 'Botswana',
		dial_code: '+267',
		code: 'BW',
		mask: '+267 00 000 0000000000',
	},
	{
		name: 'Swaziland',
		dial_code: '+268',
		code: 'SZ',
		mask: '+268 00 00 00000000000',
	},
	{
		name: 'South Africa',
		dial_code: '+27',
		code: 'ZA',
		mask: '+27 00 000 00000000000',
	},
	{
		name: 'Netherlands',
		dial_code: '+31',
		code: 'NL',
		mask: '+31 00 000 00000000000',
	},
	{
		name: 'Belgium',
		dial_code: '+32',
		code: 'BE',
		mask: '+32 000 000 0000000000',
	},
	{
		name: 'France',
		dial_code: '+33',
		code: 'FR',
		mask: '+33 000 000 0000000000',
	},
	{
		name: 'Spain',
		dial_code: '+34',
		code: 'ES',
		mask: '+34 000 000 0000000000',
	},
	{
		name: 'Cyprus',
		dial_code: '+357',
		code: 'CY',
		mask: '+357 00 000 0000000000',
	},
	{
		name: 'Hungary',
		dial_code: '+36',
		code: 'HU',
		mask: '+36 000 000 0000000000',
	},
	{
		name: 'Lithuania',
		dial_code: '+370',
		code: 'LT',
		mask: '+370 000 00 0000000000',
	},
	{
		name: 'Latvia',
		dial_code: '+371',
		code: 'LV',
		mask: '+371 00 000 0000000000',
	},
	{
		name: 'Armenia',
		dial_code: '+374',
		code: 'AM',
		mask: '+374 00 000 0000000000',
	},
	{
		name: 'Montenegro',
		dial_code: '+382',
		code: 'ME',
		mask: '+382 00 000 0000000000',
	},
	{
		name: 'Croatia',
		dial_code: '+385',
		code: 'HR',
		mask: '+385 00 000 0000000000',
	},
	{
		name: 'Slovenia',
		dial_code: '+386',
		code: 'SI',
		mask: '+386 00 000 0000000000',
	},
	{
		name: 'Macedonia',
		dial_code: '+389',
		code: 'MK',
		mask: '+389 00 000 0000000000',
	},
	{
		name: 'Italy',
		dial_code: '+39',
		code: 'IT',
		mask: '+39 0 000 000000000000',
	},
	{
		name: 'Romania',
		dial_code: '+40',
		code: 'RO',
		mask: '+40 00 000 00000000000',
	},
	{
		name: 'Switzerland',
		dial_code: '+41',
		code: 'CH',
		mask: '+41 00 000 00000000000',
	},
	{
		name: 'Denmark',
		dial_code: '+45',
		code: 'DK',
		mask: '+45 00 00 00 000000000',
	},
	{
		name: 'Sweden',
		dial_code: '+46',
		code: 'SE',
		mask: '+46 00 000 00000000000',
	},
	{
		name: 'Poland',
		dial_code: '+48',
		code: 'PL',
		mask: '+48 000 000 0000000000',
	},
	{
		name: 'Guatemala',
		dial_code: '+502',
		code: 'GT',
		mask: '+502 0 000 00000000000',
	},
	{
		name: 'El Salvador',
		dial_code: '+503',
		code: 'SV',
		mask: '+503 00 00 00000000000',
	},
	{
		name: 'Haiti',
		dial_code: '+509',
		code: 'HT',
		mask: '+509 00 00 00000000000',
	},
	{
		name: 'Peru',
		dial_code: '+51',
		code: 'PE',
		mask: '+51 000 000 0000000000',
	},
	{
		name: 'Chile',
		dial_code: '+56',
		code: 'CL',
		mask: '+56 0 0000 00000000000',
	},
	{
		name: 'Bolivia, Plurinational State of',
		dial_code: '+591',
		code: 'BO',
		mask: '+591 0 000 00000000000',
	},
	{
		name: 'French Guiana',
		dial_code: '+594',
		code: 'GF',
		mask: '+594 00000 00000000000',
	},
	{
		name: 'Malaysia',
		dial_code: '+60',
		code: 'MY',
		mask: '+60 00 000 00000000000',
	},
	{
		name: 'Malaysia',
		dial_code: '+60',
		code: 'MY',
		mask: '+60 000 000 0000000000',
	},
	{
		name: 'Australia',
		dial_code: '+61',
		code: 'AU',
		mask: '+61 0 0000 00000000000',
	},
	{
		name: 'Thailand',
		dial_code: '+66',
		code: 'TH',
		mask: '+66 00 000 00000000000',
	},
	{
		name: 'Papua New Guinea',
		dial_code: '+675',
		code: 'PG',
		mask: '+675 000 00 0000000000',
	},
	{
		name: 'Japan',
		dial_code: '+81',
		code: 'JP',
		mask: '+81 000 000 0000000000',
	},
	{
		name: 'Cambodia',
		dial_code: '+855',
		code: 'KH',
		mask: '+855 00 000 0000000000',
	},
	{
		name: 'Laos',
		dial_code: '+856',
		code: 'LA',
		mask: '+856 00 000 0000000000',
	},
	{
		name: 'Bangladesh',
		dial_code: '+880',
		code: 'BD',
		mask: '+880 00 000 0000000000',
	},
	{
		name: 'Afghanistan',
		dial_code: '+93',
		code: 'AF',
		mask: '+93 00 000 00000000000',
	},
	{
		name: 'Sri Lanka',
		dial_code: '+94',
		code: 'LK',
		mask: '+94 00 000 00000000000',
	},
	{
		name: 'Lebanon',
		dial_code: '+961',
		code: 'LB',
		mask: '+961 00 000 0000000000',
	},
	{
		name: 'Saudi Arabia',
		dial_code: '+966',
		code: 'SA',
		mask: '+966 0 000 00000000000',
	},
	{
		name: 'Oman',
		dial_code: '+968',
		code: 'OM',
		mask: '+968 00 000 0000000000',
	},
	{
		name: 'United Arab Emirates',
		dial_code: '+971',
		code: 'AE',
		mask: '+971 0 000 00000000000',
	},
	{
		name: 'Mongolia',
		dial_code: '+976',
		code: 'MN',
		mask: '+976 00 00 00000000000',
	},
	{
		name: 'Nepal',
		dial_code: '+977',
		code: 'NP',
		mask: '+977 00 000 0000000000',
	},
	{
		name: 'Turkmenistan',
		dial_code: '+993',
		code: 'TM',
		mask: '+993 0 000 00000000000',
	},
	{
		name: 'Egypt',
		dial_code: '+20',
		code: 'EG',
		mask: '+20 000 000 00000000000',
	},
	{
		name: 'South Sudan',
		dial_code: '+211',
		code: 'SS',
		mask: '+211 00 000 00000000000',
	},
	{
		name: 'Morocco',
		dial_code: '+212',
		code: 'MA',
		mask: '+212 00 0000 0000000000',
	},
	{
		name: 'Algeria',
		dial_code: '+213',
		code: 'DZ',
		mask: '+213 00 000 00000000000',
	},
	{
		name: 'Senegal',
		dial_code: '+221',
		code: 'SN',
		mask: '+221 00 000 00000000000',
	},
	{
		name: 'Ghana',
		dial_code: '+233',
		code: 'GH',
		mask: '+233 000 000 0000000000',
	},
	{
		name: 'Chad',
		dial_code: '+235',
		code: 'TD',
		mask: '+235 00 00 00 000000000',
	},
	{
		name: 'Equatorial Guinea',
		dial_code: '+240',
		code: 'GQ',
		mask: '+240 00 000 00000000000',
	},
	{
		name: 'Congo',
		dial_code: '+242',
		code: 'CG',
		mask: '+242 00 000 00000000000',
	},
	{
		name: 'Congo, The Democratic Republic of the Congo',
		dial_code: '+243',
		code: 'CD',
		mask: '+243 000 000 0000000000',
	},
	{
		name: 'Angola',
		dial_code: '+244',
		code: 'AO',
		mask: '+244 000 000 0000000000',
	},
	{
		name: 'Sudan',
		dial_code: '+249',
		code: 'SD',
		mask: '+249 00 000 00000000000',
	},
	{
		name: 'Rwanda',
		dial_code: '+250',
		code: 'RW',
		mask: '+250 000 000 0000000000',
	},
	{
		name: 'Ethiopia',
		dial_code: '+251',
		code: 'ET',
		mask: '+251 00 000 00000000000',
	},
	{
		name: 'Djibouti',
		dial_code: '+253',
		code: 'DJ',
		mask: '+253 00 00 00 000000000',
	},
	{
		name: 'Tanzania, United Republic of Tanzania',
		dial_code: '+255',
		code: 'TZ',
		mask: '+255 00 000 00000000000',
	},
	{
		name: 'Uganda',
		dial_code: '+256',
		code: 'UG',
		mask: '+256 000 000 0000000000',
	},
	{
		name: 'Zambia',
		dial_code: '+260',
		code: 'ZM',
		mask: '+260 00 000 00000000000',
	},
	{
		name: 'Madagascar',
		dial_code: '+261',
		code: 'MG',
		mask: '+261 00 00 000000000000',
	},
	{
		name: 'Namibia',
		dial_code: '+264',
		code: 'NA',
		mask: '+264 00 000 00000000000',
	},
	{
		name: 'Malawi',
		dial_code: '+265',
		code: 'MW',
		mask: '+265 000000000000000',
	},
	{
		name: 'Greece',
		dial_code: '+30',
		code: 'GR',
		mask: '+30 000 000 00000000000',
	},
	{
		name: 'Portugal',
		dial_code: '+351',
		code: 'PT',
		mask: '+351 00 000 00000000000',
	},
	{
		name: 'Luxembourg',
		dial_code: '+352',
		code: 'LU',
		mask: '+352 000 000 0000000000',
	},
	{
		name: 'Ireland',
		dial_code: '+353',
		code: 'IE',
		mask: '+353 000 000 0000000000',
	},
	{
		name: 'Albania',
		dial_code: '+355',
		code: 'AL',
		mask: '+355 000 000 0000000000',
	},
	{
		name: 'Bulgaria',
		dial_code: '+359',
		code: 'BG',
		mask: '+359 000 000 0000000000',
	},
	{
		name: 'Monaco',
		dial_code: '+377',
		code: 'MC',
		mask: '+377 000 000 0000000000',
	},
	{
		name: 'San Marino',
		dial_code: '+378',
		code: 'SM',
		mask: '+378 0000 0000000000000',
	},
	{
		name: 'Serbia',
		dial_code: '+381',
		code: 'RS',
		mask: '+381 00 000 00000000000',
	},
	{
		name: 'Czech Republic',
		dial_code: '+420',
		code: 'CZ',
		mask: '+420 000 000 0000000000',
	},
	{
		name: 'Slovakia',
		dial_code: '+421',
		code: 'SK',
		mask: '+421 000 000 0000000000',
	},
	{
		name: 'Austria',
		dial_code: '+43',
		code: 'AT',
		mask: '+43 000 000 00000000000',
	},
	{
		name: 'Guernsey',
		dial_code: '+44',
		code: 'GG',
		mask: '+44 00 0000 00000000000',
	},
	{
		name: 'Argentina',
		dial_code: '+54',
		code: 'AR',
		mask: '+54 000 000 00000000000',
	},
	{
		name: 'Brazil',
		dial_code: '+55',
		code: 'BR',
		mask: '+55 00 0000 00000000000',
	},
	{
		name: 'Colombia',
		dial_code: '+57',
		code: 'CO',
		mask: '+57 000 000 00000000000',
	},
	{
		name: 'Venezuela, Bolivarian Republic of Venezuela',
		dial_code: '+58',
		code: 'VE',
		mask: '+58 000 000 00000000000',
	},
	{
		name: 'Guadeloupe',
		dial_code: '+590',
		code: 'GP',
		mask: '+590 000 000 0000000000',
	},
	{
		name: 'Ecuador',
		dial_code: '+593',
		code: 'EC',
		mask: '+593 00 000 00000000000',
	},
	{
		name: 'Guyana',
		dial_code: '+595',
		code: 'GY',
		mask: '+595 000 000 0000000000',
	},
	{
		name: 'Uruguay',
		dial_code: '+598',
		code: 'UY',
		mask: '+598 0 000 00 000000000',
	},
	{
		name: 'Philippines',
		dial_code: '+63',
		code: 'PH',
		mask: '+63 000 000 00000000000',
	},
	{
		name: 'Russia',
		dial_code: '+7',
		code: 'RU',
		mask: '+7 000 000 00 000000000',
	},
	{
		name: 'Vietnam',
		dial_code: '+84',
		code: 'VN',
		mask: '+84 000 0000 0000000000',
	},
	{
		name: 'China',
		dial_code: '+86',
		code: 'CN',
		mask: '+86 000 0000 0000000000',
	},
	{
		name: 'Turkey',
		dial_code: '+90',
		code: 'TR',
		mask: '+90 000 000 00000000000',
	},
	{
		name: 'Pakistan',
		dial_code: '+92',
		code: 'PK',
		mask: '+92 000 000 00000000000',
	},
	{
		name: 'Jordan',
		dial_code: '+962',
		code: 'JO',
		mask: '+962 0 0000 00000000000',
	},
	{
		name: 'Syrian Arab Republic',
		dial_code: '+963',
		code: 'SY',
		mask: '+963 00 0000 0000000000',
	},
	{
		name: 'State of Palestine',
		dial_code: '+970',
		code: 'PS',
		mask: '+970 00 000 00000000000',
	},
	{
		name: 'Israel',
		dial_code: '+972',
		code: 'IL',
		mask: '+972 00 000 00000000000',
	},
	{
		name: 'Iran',
		dial_code: '+98',
		code: 'IR',
		mask: '+98 000 000 00000000000',
	},
	{
		name: 'Tajikistan',
		dial_code: '+992',
		code: 'TJ',
		mask: '+992 00 000 00000000000',
	},
	{
		name: 'Georgia',
		dial_code: '+995',
		code: 'GE',
		mask: '+995 000 000 0000000000',
	},
	{
		name: 'Kyrgyzstan',
		dial_code: '+996',
		code: 'KG',
		mask: '+996 000 000 0000000000',
	},
	{
		name: 'Uzbekistan',
		dial_code: '+998',
		code: 'UZ',
		mask: '+998 00 000 00000000000',
	},
	{
		name: 'Belarus',
		dial_code: '+375',
		code: 'BY',
		mask: '+375 00 000 00 000000000',
	},
	{
		name: 'Ukraine',
		dial_code: '+380',
		code: 'UA',
		mask: '+380 00 000 00 000000000',
	},
	{
		name: 'Liechtenstein',
		dial_code: '+423',
		code: 'LI',
		mask: '+423 000 000 00000000000',
	},
	{
		name: 'Martinique',
		dial_code: '+596',
		code: 'MQ',
		mask: '+596 000 00 00 000000000',
	},
	{
		name: 'Iraq',
		dial_code: '+964',
		code: 'IQ',
		mask: '+964 000 000 00000000000',
	},
	{
		name: 'Azerbaijan',
		dial_code: '+994',
		code: 'AZ',
		mask: '+994 00 000 00 000000000',
	},
	{
		name: 'Aland Islands',
		dial_code: '+358',
		code: 'AX',
		mask: '+358 000 000 00 000000000',
	},
];
